import { Link } from "react-router-dom";
import type { Topic } from "@/types";

interface TopicCardProps {
  topic: Topic;
  rank?: number;
}

export default function TopicCard({ topic, rank }: TopicCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/topic/${topic.id}`} className="relative block h-44 w-full overflow-hidden">
        <img
          src={topic.image}
          alt={topic.title}
          title={`${topic.title} 娱乐热点话题`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {typeof rank === "number" ? (
          <span className="absolute left-0 top-0 flex h-9 w-9 items-center justify-center bg-primary-500 font-heading text-lg font-bold text-background-50">
            {rank}
          </span>
        ) : null}
        <span className="absolute bottom-2 left-2 rounded-md bg-secondary-900/85 px-2 py-0.5 font-label text-xs text-background-50">
          {topic.category}
        </span>
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <Link to={`/topic/${topic.id}`}>
          <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
            {topic.title}
          </h3>
        </Link>
        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
          {topic.summary}
        </p>
        <div className="mt-auto flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1 font-medium text-primary-600">
            <i className="ri-fire-line h-4 w-4 flex items-center justify-center"></i>
            {topic.heat}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-chat-3-line h-4 w-4 flex items-center justify-center"></i>
            {topic.comments}
          </span>
          <span>{topic.date}</span>
        </div>
      </div>
    </article>
  );
}